import ShoppingListsTable from './ShoppingListsTable';

export default ShoppingListsTable;
